module.exports = __webpack_public_path__ + "./images/school90h.png?3ebaaf1c99dcb628287d51296d6c3afb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/school90h.png
// module id = 12
// module chunks = 0